'use strict';

var React = require('react'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    StampLink = require('../atoms/StampLink'),
    UserLink = require('../atoms/UserLink'),
    Link = require('../atoms/Link'),
    SidebarActionCreators = require('../actions/SidebarActionCreators'),
    SidebarTypes = require('../constants/SidebarTypes'),
    getThumbnailUrl = require('../utils/getThumbnailUrl'),
    pluralize = require('../utils/pluralize'),
    { PropTypes } = React;

require('./ImageAttribution.less');
require('utils/hideOnMobile.less');

var ImageAttribution = React.createClass({
  mixins: [ClassNameMixin, PureRenderMixin],

  propTypes: {
    stamp: PropTypes.object.isRequired,
    sourceStamp: PropTypes.object.isRequired,
    sourceImage: PropTypes.object.isRequired,
    sourceUser: PropTypes.object.isRequired
  },

  render() {
    var { sourceStamp, sourceImage, sourceUser, stamp } = this.props,
        isInSourceStamp = sourceStamp.id === stamp.id,
        otherUsageCount = isInSourceStamp ? sourceImage.usageCount : sourceImage.usageCount - 1,
        hasOtherUsages = otherUsageCount > 0;

    return (
      <div className={this.getClassName()}>
        {!isInSourceStamp &&
          <div className='ImageAttribution-image'>
            <StampLink stamp={sourceStamp}>
              <img src={getThumbnailUrl(sourceStamp.thumbnail, {
                mode: 'scale_crop',
                width: 48,
                height: 36
              })} />
            </StampLink>
          </div>
        }

        <div className='ImageAttribution-meta'>
          {!isInSourceStamp &&
            <span className='ImageAttribution-originalStamp'>
              Image from <StampLink bold stamp={sourceStamp} /> by <UserLink user={sourceUser} />.
            </span>
          }

          {isInSourceStamp && !sourceImage.sourcePageUrl &&
            <span className='ImageAttribution-originalStamp'>
              Uploaded by <UserLink user={sourceUser} />.
            </span>
          }

          {isInSourceStamp && sourceImage.sourcePageUrl &&
            <span className='ImageAttribution-originalStamp'>
              Image from <Link href={sourceImage.sourcePageUrl} bold>{sourceImage.sourcePageTitle}</Link>
            </span>
          }

          {hasOtherUsages &&
            this.renderOtherUsages(otherUsageCount)
          }
        </div>
      </div>
    );
  },

  renderOtherUsages(otherUsageCount) {
    return (
      <span className='ImageAttribution-otherUsages'>
        Also found in
        {' '}
        <Link bold onClick={this.handleOtherUsagesClick}>
          {otherUsageCount} {pluralize(otherUsageCount, 'more stamp', 'other stamps')}
        </Link>
        .
      </span>
    );
  },

  handleOtherUsagesClick() {
    var { stamp, sourceImage } = this.props;

    SidebarActionCreators.showSidebar(SidebarTypes.IMAGE_USED_IN_STAMPS, {
      imageUuid: sourceImage.uuid,
      excludeStampId: stamp.id
    });
  },
});

module.exports = ImageAttribution;



/** WEBPACK FOOTER **
 ** ./molecules/ImageAttribution.jsx
 **/